module.exports = __webpack_public_path__ + "static/media/Rat_Attack_web.ee0ed298.pdf";